import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {Form, Button, Modal} from 'semantic-ui-react';
import {required} from '../../../../common/components/form/common/fieldValidations';
import {InputField, DropdownField} from '../../../../common/components/form';
import {ADVISOR_MANAGEMENT_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import {ADVISOR_STATUS} from '../../../constants';
import {mapListToDropdownList} from '../../../utils';
import {UserGroup} from '../../../../floatingInventory/constants/userGroup';
class AdvisorManagementForm extends Component {
  componentDidMount() {
    const {code, dealerId, setAdvisorValue, isUserTde, dealer} = this.props;
    if (code) {
      this.props.fetchAdvisorManagementInfo(code);
    }
    this.props.fetchDealers('float');
    setAdvisorValue('dealer', isUserTde ? dealer : dealerId);
  }

  componentWillUnmount() {
    this.props.clearAdvisorManagement();
  }

  onCancelClick = () => {
    this.props.goBack();
  };

  onSubmit = async(formValues) => {
    const {closeModal, create, code, dealerId} = this.props;

    if (create) {
      await this.props.addAdvisorManagement(formValues);
    } else {
      await this.props.updateAdvisorManagement(code, dealerId, formValues);
    }
    this.props.fetchAdvisorManagementList(dealerId);
    closeModal();
  };

  render() {
    const {
      dealers,
      handleSubmit,
      submitting,
      closeModal,
      loading,
      code,
      setAdvisorValue,
      isUserTde,
    } = this.props;
    const isAvailable = ([UserGroup.coachDealer, UserGroup.tdeUser].includes(this.props.currentFlUserGroup));
    return (
      <Form
        className="admin-advisor"
        onSubmit={handleSubmit(this.onSubmit)}
        loading={submitting || loading}
      >
        <Form.Group inline>
          <label className="main">CEDULA</label>
          <Field
            name="code"
            type="text"
            size={'mini'}
            component={InputField}
            normalize={(value) => value.toUpperCase()}
            invalidMessage="Por favor, llene este campo"
            required
            validate={required}
            disabled={code || !isAvailable}
          />
        </Form.Group>
        <Form.Group inline>
          <label className="main">NOMBRE</label>
          <Field
            disabled={!isAvailable}
            name="name"
            type="text"
            size={'mini'}
            component={InputField}
            normalize={(value) => value.toUpperCase()}
            invalidMessage="Por favor, llene este campo"
            required
            validate={required}
          />
        </Form.Group>
        <Form.Group inline>
          <label className="main">DEALER</label>
          <Field
            name="dealer"
            size={'mini'}
            disabled={!isUserTde || !isAvailable}
            options={
              mapListToDropdownList(
                dealers,
                {
                  'keys': ['identification'],
                  'values': ['identification'],
                  'texts': ['name'],
                },
                false
              )
            }
            component={DropdownField}
            invalidMessage="Por favor, llene este campo"
            placeholder="Seleccione una opción"
            required
            validate={required}
          />
        </Form.Group>
        <Form.Group inline>
          <label className="main">STATUS</label>
          <Field
            disabled={!isAvailable}
            name="status"
            size={'mini'}
            options={ADVISOR_STATUS}
            component={DropdownField}
            invalidMessage="Por favor, llene este campo"
            placeholder="Seleccione una opción"
            required
            onChange={(value) => setAdvisorValue('status', value)}
            validate={required}
          />
        </Form.Group>
        <Modal.Actions>
          <Button onClick={closeModal}>CERRAR</Button>
          <Button
            positive
            type="submit"
            disabled={submitting || !isAvailable}
          >
            {'GRABAR'}
          </Button>
        </Modal.Actions>
      </Form>
    );
  }
}

export {AdvisorManagementForm};

const form = reduxForm({
  'form': ADVISOR_MANAGEMENT_FORM.name,
})(AdvisorManagementForm);

const mapStateToProps = (state, ownProps) => {
  const {
    dealer,
  } = state.advisorManagementForm.values;

  return {
    'dealers': state.dealer.list,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
    'loading': state.advisorManagementForm.loading,
    'dealerId': state.session.dealerId,
    'isUserTde': state.session.isUserFromTDE,
    'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
    dealer,
  };
};

const {
  fetchDealers,
  fetchAdvisorManagementList,
  fetchAdvisorManagementInfo,
  updateAdvisorManagement,
  addAdvisorManagement,
  clearAdvisorManagement,
  withRouter,
  navigateTo,
  setAdvisorValue,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchDealers,
    addAdvisorManagement,
    clearAdvisorManagement,
    updateAdvisorManagement,
    fetchAdvisorManagementInfo,
    fetchAdvisorManagementList,
    navigateTo,
    setAdvisorValue,
  })(form)
);
